import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "@/lib/firebase";
import { Logger } from "@/lib/app-log.js";

export async function requestFcmToken() {
  if (!("Notification" in window) || !messaging) {
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    Logger.warn("[FCM] Bildirim izni reddedildi!");
    return null;
  }

  const vapidKey = import.meta.env.VITE_FCM_VAPID_KEY;

  if (!vapidKey) {
    Logger.error("[FCM] VAPID Key bulunamadı! .env dosyasını kontrol edin.");
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/'
    });

    const currentToken = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration
    });
    if (!currentToken) {
      Logger.warn("[FCM] Token alınamadı (boş döndü).");
      return null;
    }
    return currentToken;
  } catch (error) {
    Logger.error("[FCM] Token alma hatası detaylı:", { code: error?.code, error: error?.message });
    // Hata 'messaging/invalid-vapid-key' ise anahtar yanlıştır.
    return null;
  }
}

export function subscribeToForegroundMessages(handler) {
  if (!messaging) return () => { };
  return onMessage(messaging, (payload) => {
    try {
      handler(payload);
    } catch (error) {
      Logger.error("Error in foreground FCM handler", { error: error?.message });
    }
  });
}
